import React, { useEffect, useState, createElement } from 'react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { highlightJSON } from '../utils/highlightJSON';
const EMAIL = 'jason@andoe.work';
const LINKEDIN = 'https://www.linkedin.com/in/jason-jm-yang/';
const pageData = {
  $schema: 'https://schema.org/ContactPage',
  name: 'Andoe / Contact',
  frontmatter: {
    page: 'Contact',
    topic: 'Get in touch',
    status: 'Active'
  },
  hero: {
    kicker: 'Andoe / Contact',
    headline: 'Talk to our team.'
  },
  contact: {
    preferred: ['email', 'linkedin'],
    email: EMAIL,
    linkedin: LINKEDIN
  }
};
export function ContactPage() {
  const [jsonHtml, setJsonHtml] = useState('');
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    setJsonHtml('<span class="c">// how to reach us, as structured data</span>\n\n' + highlightJSON(pageData));
  }, []);
  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = EMAIL;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch {}
      document.body.removeChild(textarea);
    }
  };
  return <>
      <Navigation data-id="element-133" />

      <main className="wrap report-main" data-id="element-134">
        <article className="report" data-id="element-135">
          {/* frontmatter */}
          <header className="frontmatter" data-id="element-136">
            <div className="fm-cell" data-id="element-137">
              <span className="lbl" data-id="element-138">Page</span>
              <span className="val" data-id="element-139">Contact</span>
            </div>
            <div className="fm-cell" data-id="element-140">
              <span className="lbl" data-id="element-141">Topic</span>
              <span className="val" data-id="element-142">Get in touch</span>
            </div>
            <div className="fm-cell" data-id="element-143">
              <span className="lbl" data-id="element-144">Status</span>
              <span className="val" data-id="element-145">Active</span>
            </div>
          </header>

          {/* HERO */}
          <section className="hero" style={{
          borderBottom: 'none',
          marginBottom: '16px',
          paddingBottom: '0'
        }} data-id="element-146">
            <div className="kicker" data-id="element-147">Andoe / Contact</div>
            <h1 data-id="element-148">Talk to our team.</h1>
          </section>

          {/* CONTACT OPTIONS */}
          <section className="report-section" data-id="element-149">
            <div className="entry" style={{
            borderBottom: 'none'
          }} data-id="element-150">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-151">
                Two simple ways to reach me. Pick whichever you prefer.
              </p>

              <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              gap: '16px',
              maxWidth: '560px'
            }} data-id="element-152">
                {/* EMAIL CARD */}
                <button type="button" onClick={handleCopyEmail} aria-label={`Copy email ${EMAIL}`} style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '8px',
                padding: '20px',
                background: 'transparent',
                border: '1px solid var(--rule)',
                borderRadius: '12px',
                color: 'var(--ink)',
                fontFamily: 'inherit',
                textAlign: 'left',
                cursor: 'pointer',
                transition: 'border-color 160ms ease, transform 160ms ease'
              }} onMouseEnter={e => {
                e.currentTarget.style.borderColor = 'var(--ink)';
              }} onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'var(--rule)';
              }} data-id="element-153">
                  <span style={{
                  fontSize: '11px',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  opacity: 0.6
                }} data-id="element-154">
                    Email
                  </span>
                  <span style={{
                  fontSize: '17px',
                  fontWeight: 500
                }} data-id="element-155">
                    {EMAIL}
                  </span>
                  <span aria-live="polite" style={{
                  fontSize: '13px',
                  opacity: 0.7,
                  marginTop: '4px'
                }} data-id="element-156">
                    {copied ? 'Copied ✓' : 'Click to copy'}
                  </span>
                </button>

                {/* LINKEDIN CARD */}
                <a href={LINKEDIN} target="_blank" rel="noopener noreferrer" aria-label="Open LinkedIn profile in a new tab" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '8px',
                padding: '20px',
                background: 'transparent',
                border: '1px solid var(--rule)',
                borderRadius: '12px',
                color: 'var(--ink)',
                fontFamily: 'inherit',
                textDecoration: 'none',
                transition: 'border-color 160ms ease'
              }} onMouseEnter={e => {
                e.currentTarget.style.borderColor = 'var(--ink)';
              }} onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'var(--rule)';
              }} data-id="element-157">
                  <span style={{
                  fontSize: '11px',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  opacity: 0.6
                }} data-id="element-158">
                    LinkedIn
                  </span>
                  <span style={{
                  fontSize: '17px',
                  fontWeight: 500
                }} data-id="element-159">
                    /in/jason-jm-yang
                  </span>
                  <span style={{
                  fontSize: '13px',
                  opacity: 0.7,
                  marginTop: '4px'
                }} data-id="element-160">
                    Open profile →
                  </span>
                </a>
              </div>
            </div>
          </section>

          <Footer data-id="element-161" />
        </article>

        <pre className="json-view" dangerouslySetInnerHTML={{
        __html: jsonHtml
      }} data-id="element-162" />
      </main>
    </>;
}